import { Injectable, inject } from '@angular/core'
import { environment } from '@front-app-environments/environment'
import { NetworkingService } from '../../networking/services/networking.service'
import { Observable } from 'rxjs'
import { Region } from '@agroone/entities'

@Injectable({
  providedIn: 'root',
})
export class RegionNetworkService {
  private network = inject(NetworkingService)

  get(): Observable<Region[]> {
    return this.network.get(`${environment.apiUrl}${environment.regions}`) as Observable<Region[]>
  }
}
